export class IChangeReservation
{
    operationType : number;
    id_nofesh : number;
    ms_zehut_mazmin :number;
}